import axios from "../../http";
import {
  PRODUCT_DETAILS_FAIL,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_LIST_FAIL,
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_FEATURED_LIST_REQUEST,
  PRODUCT_FEATURED_LIST_SUCCESS,
  PRODUCT_FEATURED_LIST_FAIL,
} from "../Constants/ProductConstants";

const PRODUCT_CACHE_TTL = 1000 * 60 * 5;

export const buildProductListKey = ({
  keyword = "",
  pageNumber = "",
  categoryId = "",
  departmentId = "",
  featuredOnly = false,
}) => {
  return `keyword=${keyword || ""}|page=${pageNumber || 1}|category=${
    categoryId || "all"
  }|department=${departmentId || "all"}|featured=${
    featuredOnly ? "1" : "0"
  }`;
};

export const listProduct =
  (
    keyword = "",
    pageNumber = "",
    categoryId = "",
    featuredOnly = false,
    departmentId = ""
  ) =>
  async (dispatch, getState) => {
    const key = buildProductListKey({
      keyword,
      pageNumber,
      categoryId,
      departmentId,
      featuredOnly,
    });

    const {
      productList: { productsByKey = {} },
    } = getState();

    const cached = productsByKey[key];
    const isFresh =
      cached && Date.now() - cached.fetchedAt < PRODUCT_CACHE_TTL;

    dispatch({
      type: PRODUCT_LIST_REQUEST,
      payload: { key },
    });

    if (isFresh) {
      dispatch({
        type: PRODUCT_LIST_SUCCESS,
        payload: {
          key,
          data: {
            products: cached.products,
            page: cached.page,
            pages: cached.pages,
            count: cached.count,
          },
        },
      });
      return;
    }

    try {
      const params = new URLSearchParams();

      if (pageNumber) params.append("pageNumber", pageNumber);

      let url = "/api/products";

      if (featuredOnly) {
        url = "/api/products/featured/page";
      } else {
        if (keyword) params.append("keyword", keyword);
        if (categoryId) params.append("categoryId", categoryId);
        if (departmentId) params.append("departmentId", departmentId);
      }

      const queryString = params.toString();
      const finalUrl = queryString ? `${url}?${queryString}` : url;

      const { data } = await axios.get(finalUrl);

      dispatch({
        type: PRODUCT_LIST_SUCCESS,
        payload: { key, data },
      });
    } catch (error) {
      dispatch({
        type: PRODUCT_LIST_FAIL,
        payload: {
          key,
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

export const listFeaturedProducts =
  (limit = 12) =>
  async (dispatch, getState) => {
    const {
      productFeaturedList: { products = [], fetchedAt = null },
    } = getState();

    const isFresh =
      fetchedAt &&
      Date.now() - fetchedAt < PRODUCT_CACHE_TTL &&
      products.length > 0;

    dispatch({ type: PRODUCT_FEATURED_LIST_REQUEST });

    if (isFresh) {
      dispatch({
        type: PRODUCT_FEATURED_LIST_SUCCESS,
        payload: products,
      });
      return;
    }

    try {
      const { data } = await axios.get(
        `/api/products/featured/list?limit=${limit}`
      );

      dispatch({
        type: PRODUCT_FEATURED_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PRODUCT_FEATURED_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const listProductDetails = (id) => async (dispatch, getState) => {
  const {
    productDetails: { productCache = {} },
  } = getState();

  if (productCache[id]) {
    dispatch({
      type: PRODUCT_DETAILS_SUCCESS,
      payload: productCache[id],
    });
    return;
  }

  try {
    dispatch({ type: PRODUCT_DETAILS_REQUEST });

    const { data } = await axios.get(`/api/products/${id}`);

    dispatch({
      type: PRODUCT_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};